import { createConfig, http } from 'wagmi';
import { polygon } from 'wagmi/chains';
import { injected, walletConnect } from 'wagmi/connectors';

const walletConnectProjectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID?.trim();
const hasValidWalletConnectProjectId = Boolean(walletConnectProjectId && walletConnectProjectId.length >= 20);

export const EVM_CHAINS = [polygon] as const;

// Only Polygon (POS) is supported for send/receive
export const NETWORK_TO_CHAIN_ID: Record<string, number> = {
  'Polygon (POS)': polygon.id,
};

export const CHAIN_ID_TO_NETWORK: Record<number, string> = Object.fromEntries(
  Object.entries(NETWORK_TO_CHAIN_ID).map(([k, v]) => [v, k])
);

export const isEVMNetwork = (networkName: string): boolean => networkName in NETWORK_TO_CHAIN_ID;

const evmConnectors = hasValidWalletConnectProjectId && walletConnectProjectId
  ? [
      injected(),
      walletConnect({
        projectId: walletConnectProjectId,
        showQrModal: true,
      }),
    ]
  : [injected()];

export const wagmiConfig = createConfig({
  chains: [polygon],
  connectors: evmConnectors,
  transports: {
    [polygon.id]: http('https://polygon-rpc.com'),
  },
});
